import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
	"maintenance":{
        "title": "MAINTENANCE NOTICE",
        "label":{
            "title": "Under Maintenance",
            "description": "We are currently performing scheduled maintenance in order to improve the server to bring better experiences to our users.",
            "duration": "Duration:"
        },
        "description": `We are performing scheduled maintenance to improve the server to bring better experience to our users. <br/>We're sorry for any inconvenience caused. Please come back later. <br/> Please email us at <a class="a-link" href="mailto: support@fireapps.io">support@fireapps.io</a> if you have any questions.`,
        "buttons":{
            "goto_help_center": "Go to help center"
        }
    }
})